import type { ChartResult, NativeFilterSpec } from "@bi/shared/types";

/** The authored facet is a JSON array from the unfiltered source cohort. */
export function resultFilterOptions(
  filter: NativeFilterSpec,
  result: ChartResult | undefined,
  selected: readonly string[],
) {
  const column = filter.options_result_column;
  const index = column ? (result?.columns.indexOf(column) ?? -1) : -1;
  const raw = index >= 0 ? result?.rows[0]?.[index] : undefined;
  let values: string[] = [];
  if (typeof raw === "string") {
    try {
      const parsed: unknown = JSON.parse(raw);
      if (Array.isArray(parsed)) values = parsed.filter((v): v is string => typeof v === "string");
    } catch {
      /* Keep selected values available while a facet is unavailable. */
    }
  }
  const names = new Intl.DisplayNames(["en"], { type: "region" });
  return [...new Set([...values, ...selected])].map((value) => ({
    value,
    label:
      value === "unknown"
        ? "Unknown"
        : filter.target_column === "country" && /^[A-Z]{2}$/.test(value)
          ? `${names.of(value) ?? value} (${value})`
          : value,
  }));
}
